import { render, staticRenderFns } from "./v-header.vue?vue&type=template&id=adcfd1be&scoped=true"
import script from "./v-header.vue?vue&type=script&lang=js"
export * from "./v-header.vue?vue&type=script&lang=js"
import style0 from "./v-header.vue?vue&type=style&index=0&id=adcfd1be&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcfd1be",
  null
  
)

export default component.exports